import MaterialReactTable from "material-react-table";
import { useState } from "react";
import {
  EmptyPaper,
  LoadingError,
  LoadingPaper,
} from "../../LoadingComponents";
import { Box, Dialog, IconButton, MenuItem } from "@mui/material";
import { Visibility as ViewIcon } from "@mui/icons-material";
import { useGetPatientReports } from "../useReportQueries";
import { commonColumns, spo2Columns } from "./TabsColumns";
import SPO2Report from "../ViewReport/SPO2Report";

function SPO2Tab({ patient_id }) {
  const dataQuery = useGetPatientReports(patient_id, 1);

  // === ViewReport modal handling ===
  const [openViewReport, setOpenViewReport] = useState(false);
  const [selectedReport, setSelectedReport] = useState(null);

  const handleOpenViewReport = (report_id) => {
    setSelectedReport(report_id);
    setOpenViewReport(true);
  };
  const handleCloseViewReport = () => {
    setOpenViewReport(false);
  };

  const tableColumns = [...commonColumns, ...spo2Columns];

  return (
    <main
      style={{
        width: "100%",
      }}
    >
      <Dialog open={openViewReport} fullScreen>
        <SPO2Report
          patient_id={patient_id}
          closeModal={handleCloseViewReport}
          report_id={selectedReport}
        />
      </Dialog>

      {dataQuery.isLoading ? (
        <LoadingPaper />
      ) : dataQuery.isError ? (
        <LoadingError error={dataQuery.error} />
      ) : (
        dataQuery.isSuccess &&
        (dataQuery.data.reports.length === 0 ? (
          <EmptyPaper message={"Nessun report SPO2 associato al paziente"} />
        ) : (
          <MaterialReactTable
            columns={tableColumns}
            data={dataQuery.data?.reports || []}
            initialState={{
              density: "compact",
              showColumnFilters: false,
            }}
            enablePagination={true}
            enableBottomToolbar={false}
            enableTopToolbar={false}
            enableSorting={false}
            muiTablePaperProps={{
              elevation: 0,
            }}
            muiTableContainerProps={{
              sx: {
                overflowX: "hidden",
              },
            }}
            enableColumnResizing
            enableColumnActions={false}
            enableRowSelection={false}
            displayColumnDefOptions={{
              "mrt-row-actions": { header: "Report" },
            }}
            enableRowActions={true}
            positionActionsColumn="last"
            renderRowActions={({ row, table }) => [
              <IconButton
                key="view"
                disabled={
                  row.original.data.SPO2 === null ||
                  row.original.data.SPO2 === undefined
                }
                onClick={() => {
                  handleOpenViewReport(row.original.id);
                }}
              >
                <ViewIcon color="primary" />
              </IconButton>,
            ]}
          />
        ))
      )}
    </main>
  );
}

export default SPO2Tab;
